export default {"src":"/_next/static/media/x-twitter.f65a4548.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};